<template>
  <div>
    <div class="d-flex">
      <div class="mr-auto">
        <button class="btn btn-secondary" @click="refresh">
          <i class="fas fa-sync-alt"></i>
        </button>
        <button class="btn btn-purple" v-if="canCreate" @click="onCreate">
          <i class="far fa-file"></i>
        </button>
      </div>
      <div class="align-self-end">
        <input-debounced
            v-model="search"
            :clearable="true"
            :autofocus="true"
            placeholder="Search"
            class="search-bar w-300 mb-2"
        ></input-debounced>
      </div>
    </div>
    <base-table
        :base-url="urlWithFilters"
        ref="baseTable"
        @load-success="onLoadSuccess"
        @refresh="onRefresh"
        :current-page="currentPage"
        v-loading="isRefreshing"
        element-loading-spinner="el-icon-loading"
    >
      <template v-slot>
        <el-table
            :data="items"
            stripe
            class="w-100"
        >
          <el-table-column
              prop="model.id"
              label="Id"
              min-width="80"
          ></el-table-column>
          <el-table-column
              prop="model.name"
              label="Name"
              min-width="250"
          ></el-table-column>
          <el-table-column
              prop="model.slug"
              label="Name"
              min-width="250"
          ></el-table-column>
          <el-table-column label="Actions" v-slot="{row}">
            <actions-column :row="row" @edit="onEdit" @delete="onDelete"></actions-column>
          </el-table-column>
        </el-table>
      </template>
    </base-table>
    <el-pagination
        layout="prev, pager, next"
        :total="total"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        class="text-right"
    ></el-pagination>
  </div>
</template>

<script>
import BaseTable from '../../../components/role/table';
import ActionsColumn from '../../../components/role/actions-column';
import eventBus from "../../../event-bus";

export default {
  extends: BaseTable,

  components: {
    ActionsColumn,
  },

  props: {
    canCreate: Boolean,
    createUrl: String,
  },

  created() {
    eventBus.$on('refresh-role-table', this.refresh);
  },

  beforeDestroy() {
    eventBus.$off('refresh-role-table', this.refresh);
  }
}
</script>
